import angular from 'angular';
import uiRouter from 'angular-ui-router';
import newsListComponent from './newsList.component';
import NewsItem from '../newsItem/newsItem';
// truncate filters
import 'angular-truncate-2';

let newsListModule = angular.module('newsList', [uiRouter, NewsItem, 'truncate'])
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider
      .state('apps.digitalAgenda', {
        url: '/digital-agenda',
        component: 'newsList',
        resolve: {
          news: (AppsService) => AppsService.digitalAgenda(),
          navigation: () => false,
          $title: () => 'Agenda Digitale'
        }
      })
      .state('apps.projectManager.list', {
        url: '/:issueId/list?name',
        component: 'newsList',
        resolve: {
          news: (AppsService, $stateParams) => AppsService.projectManager($stateParams.issueId),
          navigation: () => true,
          $title: ($stateParams) => `Progetto Manager - ${$stateParams.name}`
        }
      });
  })
  .component('newsList', newsListComponent)
  .name;

export default newsListModule;



// WEBPACK FOOTER //
// ./client/app/components/apps/newsList/newsList.js